/**
 * @Description
 */
export interface MockDemo {
  a: Function;
}

/**
 * 任务状态 status
 */
export enum TaskStatus {
  /** 待指派 */
  WaitAssign = 10,
  /** 进行中 */
  Processing = 20,
  /** 已变更 */
  Changed = 30,
  /** 已完成 */
  Complete = 40,
  /** 已关闭 */
  Closed = 50,
}

/** 跟进状态 followingStatus */
export enum FollowingStatus {
  // 其他模板的跟进状态
  /** 计划中 */
  Planing = 1,
  /** 沟通中 */
  Communicating = 2,
  /** 等位置 */
  WaitingPlace = 3,
  /** 已确定 */
  Confirmed = 4,
  /** 已开业 */
  Opened = 5,

  // 森马的跟进状态
  /** 建联中 */
  EstablishConn = 6,
  /** 已落位 */
  Located = 7,
  /** 商务谈判 */
  Negotiation = 8,
  /** 已立项 */
  Launched = 9,
  /** 放弃 */
  Abandon = 10,
}
